import * as React from 'react';
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import { useEffect } from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import {
  IconButton,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Table,
  TableCell,
  Paper,
} from '@mui/material';
import { FileTableData, UploadedFile } from '../../../types/files';
import returnDate from '../../../utils/dateTime';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(7, 42, 61)',
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

interface FilesTableProps {
  files: UploadedFile[];
  downloadFile: Function;
}

const FilesTable: React.FC<FilesTableProps> = ({ files, downloadFile }) => {
  const [generatedRows, setGeneratedRows] = React.useState<FileTableData[]>([]);

  useEffect(() => {
    const createRows = files.map((file: UploadedFile) => {
      const fileName = file.name;
      const firstName = file.name.split('_')[0];
      const lastName = file.name.split('_')[1];
      const uploadDate = returnDate(file.date);
      return { firstName, lastName, uploadDate, fileName };
    });
    setGeneratedRows(createRows);
  }, [files]);

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell align="center">Name</StyledTableCell>
            <StyledTableCell align="center">Upload Date</StyledTableCell>
            <StyledTableCell align="center">Download</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {generatedRows.map((row: FileTableData) => (
            <StyledTableRow key={row.fileName}>
              <StyledTableCell component="th" scope="row" align="center">
                {row.firstName} {row.lastName}
              </StyledTableCell>
              <StyledTableCell align="center">{row.uploadDate}</StyledTableCell>
              <StyledTableCell align="center">
                <IconButton
                  aria-label="download"
                  onClick={() => {
                    downloadFile(row.fileName);
                  }}
                >
                  <DownloadIcon />
                </IconButton>
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FilesTable;
